export const MAX_FILE_SIZE = {
  image: 5,
  file: 50,
} as const;
